import React from "react";
import { DocumentViewer } from "react-documents";
import styled from "styled-components";

const DocWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;

  /* Apply sizing/styles to our viewer container */
  .docviewerFulscrn {
    display: flex;
    width: 100%;
    min-height: 16rem;
    height: 19rem;
    background-color: black;
    position: relative;
  }

  /* REMOVE the new-tab icon */
  .rd__button--open {
    display: none !important;
  }

  .rd__toolbar button[aria-label="Open in new tab"],
  .rd__toolbar button[title="Open in new tab"] {
    display: none !important;
  }
`;

const PPT = (props) => {
  return (
    <DocWrapper>
      <DocumentViewer
        className="docviewerFulscrn"
        // viewerUrl={"https://docs.google.com/gview?url=%URL%&embedded=true"}
        url={props.url}
        // googleCheckContentLoaded={true}
      />
    </DocWrapper>
  );
};

export default PPT;
